import type {RouteRecordRaw} from "vue-router";

export const routeName = 'MainValidate';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'check',
    component: () => import('@/pages/ValidateDoc'),
};
